/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable array-callback-return */
import { Spin, Form, Input, Radio, DatePicker, Upload, message, Button as AntdButton, Select, Tooltip, Modal, ConfigProvider,Row as ARow,Col as ACol} from "antd";
import { useLayoutEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { convertToObjectKeyString, SelectFill, downloadBlob } from "Utils/Common";
import { Card, Col, Row, Button } from "react-bootstrap";
import { useIntl } from 'react-intl';
import { UploadOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import SingleLoanServices from "services/services/SingleLoanServices";
import UserService from 'services/UserService';
import { PaymentMethodOptions, ReferenceRateBaseOptions } from "constants/Constants";
import moment from "moment";
import type { UploadProps } from 'antd';
import fi_translation from 'locale/fi';
import localeFI from "antd/lib/locale/fi_FI";
import localeEN from "antd/lib/locale/en_US";
import 'moment/locale/fi';
import { AiOutlinePlus } from "react-icons/ai";

const Locale: any = {
    fi: fi_translation,
};

const SingleLoanViewModeratorForm = (props: any) => {
    const [form] = Form.useForm()
    const intl = useIntl();
    const [loading, setLoading] = useState<boolean>(false);
    const [fileName, setFileName] = useState<any>();
    const [fileValue, setFileValue] = useState<any>();
    // const [fileLoading, setFileLoading] = useState<boolean>(false);
    const [uploadedFileList, setUploadedFileList] = useState<any>([]);
    const [tenderRequestData, setTenderRequestData] = useState<any>({});
    const [open, setOpen] = useState<boolean>(false);
    const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
    const [state, setState] = useState<any>();
    const [deleteVal, setDeleteVal] = useState<any>();
    const [contactName, setContactName] = useState<any>();
    const [contactEmail, setContactEmail] = useState<any>();
    const [contactPhone, setContactPhone] = useState<any>();
    const [contactPhoneCode, setContactPhoneCode] = useState<any>();
    const [offerMessage, setOfferMessage] = useState<any>();
    const navigate = useNavigate();
    const [loanDataInfo, setLoanDataInfo] = useState('');

    useLayoutEffect(() => {
        getTenderRequestData(props?.tender_req_id, false);
        // console.log(fileName,fileValue)
        setDeleteVal(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props]);

    const downloadBlobFile = async (docId:any) => {
        setLoading(true);
        await downloadBlob(docId);
        setLoading(false);
    }

    const TranslateStringFin = (string:any) => {
        let key:any = convertToObjectKeyString(string);
        let value = Locale['fi'][key];
        if(value===key){
            // console.log('translate',"\""+key+"\": \""+string+"\",")
        }
        // return value;
        return (value===key) ? string : value;
    };

    const onFormSubmit = (values: any) => {
        if (uploadedFileList?.length === 0) {
            setOpen(false);
            return message.error(TranslateStringFin('please_select_attachment'));
        } 
        if (!values?.offer_margin) {
            setOpen(false);
            return message.error('Please select margin');
        } else if (isNaN(values?.offer_margin?.replaceAll(",", ""))) {
            setOpen(false);
            return message.error('Please select margin');
        }

        let phoneCode = contactPhoneCode ? contactPhoneCode.trim(): '';
        let phone = contactPhone ? contactPhone.trim(): '';

        
        let formDataLocal: any = {
            ...values,
            "loan_tender_id": tenderRequestData?.loan_tender_id,
            "loan_credit_id": tenderRequestData?.loan_credit_id,
            "bank_ids": tenderRequestData?.bank_id,
            "offer_payment_method": values?.offer_payment_method?.toString(),
            "offer_ref_rate_base": values?.offer_ref_rate_base?.toString(),
            "loan_data_customername": tenderRequestData?.LOAN_DATA?.loan_data_customername,
            "loan_data_name": tenderRequestData?.LOAN_DATA?.loan_data_name,
            "loan_data_agreement": tenderRequestData?.LOAN_DATA?.loan_data_agreement,
            "time_remaining": tenderRequestData?.LOAN_DATA?.time_remaining,
            "offer_contact_phone": phoneCode ? "+" + phoneCode?.trim() +" "+phone?.trim() : phone?.trim(),
            "update_by":props?.type === 'bank'?'bank':'moderator_offer',
            "tender_req_status": 1,
            "offer_submit_at": new Date()

        }
        delete formDataLocal.offer_contact_phone_code;

        setLoading(true);
        setConfirmLoading(true);
        SingleLoanServices
            .updateLoanOffer(formDataLocal, tenderRequestData?.tender_req_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(TranslateStringFin("updated_successfully"));
                    if (props?.type === 'bank') {
                        setFileValue("")
                        setFileName("")
                    }
                    form.resetFields();
                    if(props?.type === 'bank'){
                        setOfferMessage("");
                        setContactName("");
                        setContactPhoneCode("");
                        setContactPhone("");


                        
                    }
                    getTenderRequestData(props?.tender_req_id, false)
                } else if (response?.data?.code === 500) {
                    message.error(TranslateStringFin('tender_deadline_is_passed'));

                }
                setLoading(false);
                setOpen(false);
                setConfirmLoading(false);
            })
            .catch((err: any) => {
                console.log(err)
                setLoading(false);
                setOpen(false);
                setConfirmLoading(false);
            });
    };

    const getTenderRequestData = (id: any, check: any, resetVal:any = false) => {
        setLoading(true);
        SingleLoanServices
        .getTenderRequestData(id)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                setTenderRequestData(response?.data?.data)
                const tenderData = response?.data?.data;
                const endTender = response?.data?.data?.LOAN_TENDER_DATA?.loan_tender_status;
                let phoneNumber = '';
                let phoneCode = '';

                if(tenderData?.LOAN_DATA?.loan_data_info){
                    setLoanDataInfo(tenderData?.LOAN_DATA?.loan_data_info);
                }

                if(tenderData?.offer_contact_phone && tenderData?.offer_contact_phone.charAt(0) === "+"){
                    let offerContact = tenderData?.offer_contact_phone.substring(1);
                    offerContact = offerContact.split(" ");
                     phoneCode = offerContact[0];
                     offerContact.shift();
                     phoneNumber = offerContact.join(" ").trim();
                 } else if(tenderData?.offer_contact_phone) {
                     phoneNumber = tenderData?.offer_contact_phone.trim();
                 }
 
                if(props?.type === 'bank' && endTender === 'end_tender'){
                    navigate('/tender-closed');
                }

                if (check) {
                    setFileValue(tenderData?.LOAN_DATA?.LOAN_DOC?.filter((val: any) => val?.loan_status_doc_type === "bank_offer"))
                }
                if (props?.type === 'bank' && !check) {
                    form.setFieldValue('offer_payment_method', tenderData?.loan_data_loan_type ? tenderData?.loan_data_loan_type : SelectFill(PaymentMethodOptions, tenderData?.LOAN_DATA?.loan_data_loan_type));
                    form.setFieldValue('offer_ref_rate_base', tenderData?.loan_data_interest_rate_bond ? tenderData?.loan_data_interest_rate_bond : SelectFill(ReferenceRateBaseOptions, tenderData?.LOAN_DATA?.loan_data_interest_rate_bond));
                    form.setFieldValue('offer_interval', tenderData?.LOAN_DATA?.loan_data_agreed_shortening_period ? tenderData?.LOAN_DATA?.loan_data_agreed_shortening_period : tenderData?.offer_interval);
                    form.setFieldValue('offer_span_year', tenderData?.offer_span_year ? tenderData?.offer_span_year : tenderData?.LOAN_DATA?.time_remaining);
                }
                if (props?.type !== 'bank' && !check) {
                    setFileValue(tenderData?.LOAN_DATA?.LOAN_DOC?.filter((val: any) => val?.loan_status_doc_type === "bank_offer"))
                    form.setFieldValue('offer_margin', tenderData?.offer_margin);
                    form.setFieldValue('offer_payment_method', tenderData?.offer_payment_method.length > 0 ? tenderData?.offer_payment_method : SelectFill(PaymentMethodOptions, tenderData?.LOAN_DATA?.loan_data_loan_type));
                    form.setFieldValue('offer_ref_rate_base', tenderData?.offer_ref_rate_base.length > 0 ? tenderData?.offer_ref_rate_base : SelectFill(ReferenceRateBaseOptions, tenderData?.LOAN_DATA?.loan_data_interest_rate_bond));
                    form.setFieldValue('offer_interval', tenderData?.offer_interval ? tenderData?.offer_interval : tenderData?.LOAN_DATA?.loan_data_agreed_shortening_period);
                    form.setFieldValue('offer_span_year', tenderData?.offer_span_year ? tenderData?.offer_span_year : tenderData?.LOAN_DATA?.time_remaining);
                    form.setFieldValue('offer_span_year_modified', tenderData?.offer_span_year_modified ? tenderData?.offer_span_year_modified : "");
                    form.setFieldValue('offer_sanction', tenderData?.offer_sanction);
                    form.setFieldValue('offer_fee', tenderData?.offer_fee);
                    form.setFieldValue('offer_transfer_payment', tenderData?.offer_transfer_payment);
                    form.setFieldValue('offer_valid_date', tenderData?.offer_valid_date ? moment(tenderData?.offer_valid_date) : null);
                    form.setFieldValue('offer_estimated_mortage_price', tenderData?.offer_estimated_mortage_price ? tenderData?.offer_estimated_mortage_price : tenderData?.BANK_DATA?.bank_mortage_price);
                    form.setFieldValue('offer_message', tenderData?.offer_message);
                    form.setFieldValue('offer_contact_name', tenderData?.offer_contact_name);
                    form.setFieldValue('offer_contact_email', tenderData?.offer_contact_email);
                    form.setFieldValue('offer_contact_phone_code', phoneCode);
                    form.setFieldValue('offer_contact_phone', phoneNumber);
                    form.setFieldValue('max_loan_time', tenderData?.max_loan_time);
                }
                if (response?.data?.data?.LOAN_DATA?.LOAN_DOC) {
                    let tenderList = response?.data?.data?.LOAN_DATA?.LOAN_DOC;
                    if(props?.type === 'bank' ) {
                        if (tenderList?.length > 0) {
                            tenderList = tenderList?.filter((element: any, index: any) => {
                                if((element?.loan_status_is_submit === 0 || element?.loan_status_is_submit === null ) && !resetVal ){
                                    // element.name = ((props?.type !== 'bank')?TranslateStringFin("attachment"):TranslateStringFin("attachment")) + " "+(index + 1);
                                    element.name = element?.loan_original_filename > 15 ? `${element?.loan_original_filename.substring(0, 15)}...` : element?.loan_original_filename;
                                    element.url = element?.loan_status_id;
                                    return element;
                                }
                            });
                        }
                    } else {
                        if (tenderList?.length > 0) {
                            tenderList = tenderList?.map(function (element: any, index: any) {
                                element.name = element?.loan_original_filename > 15 ? `${element?.loan_original_filename.substring(0, 15)}...` : element?.loan_original_filename;
                                // element.name = ((props?.type !== 'bank')?TranslateStringFin("attachment"):TranslateStringFin("attachment")) + " "+(index + 1);
                                element.url = element?.loan_status_id;
                                return element;
                            });
                        }
                    }

                    setUploadedFileList(tenderList)
                }
            }
            setLoading(false);
        })
        .catch((err: any) => {
            if(err?.code === 'ERR_BAD_REQUEST' && props?.type === "bank"){
                message.error("Bad Authentication");
                 navigate("/pankki/");
            }
            setLoading(false);
        });
    }

    const propsFile: UploadProps = {
        name: 'file',
        action: process.env.REACT_APP_API_URL_TARGET + 'uploadmultiplepdf',
        headers: {
            Authorization: `Bearer ${UserService.getValidToken()}`
        },
        data: {
            filetype: "bank_offer",
            customerid: tenderRequestData?.LOAN_DATA?.loan_data_customerid,
            creditid: tenderRequestData?.LOAN_DATA?.loan_data_credit_id,
            loan_tender_id: tenderRequestData?.loan_tender_id,
            loanname: tenderRequestData?.LOAN_DATA?.loan_data_name,
            tender_req_id: props?.tender_req_id
        },
        onPreview(previewInfo){
            downloadBlobFile(previewInfo?.url)
        },
        onChange(info) {
            if (info?.file?.status === 'uploading') {
                setLoading(true)
                setTimeout(() => {
                    getTenderRequestData(props?.tender_req_id, true)    
                    setLoading(false)
                    message.success(`${info.file.name} `+ TranslateStringFin('file_uploaded_successfully'));
                }, 7000);
            }
            if (info.file.status === 'done') {
                getTenderRequestData(props?.tender_req_id, true)
                setLoading(false)
                setFileName(info.file.name.length > 15 ? `${info.file.name.substring(0, 15)}...` : info.file.name)
                message.success(`${info.file.name} `+ TranslateStringFin('file_uploaded_successfully'));
            }else if (info.file.status === 'error') {
                setLoading(false)
                message.error(info?.file?.response?.message);
            }
        },
        onRemove(info:any){
            let index = uploadedFileList.find((f:any)=>f.url===info?.url);
            uploadedFileList?.splice(index, 1);
            setUploadedFileList(uploadedFileList);

            if(info?.loan_status_id){
                const deleteData:any = {
                    loan_status_doc_status: 0
                }
        
                setConfirmLoading(true);
                SingleLoanServices
                .deleteAttachment(deleteData, info?.loan_status_id)
                .then((response: any) => {
                    if (response?.data?.code === 200) {
                        message.success(intl.formatMessage({ id: convertToObjectKeyString("deleted_successfully") }));
                        getTenderRequestData(props?.tender_req_id, false)
                        setOpen(false)
                    }
                    if (response?.data?.code === 500) {
                        message.error(response?.data?.msg);
                        setOpen(false)
                    }
                    setConfirmLoading(false);
                })
                .catch((err: any) => {
                    message.error("There was some error");
                    console.log(err)
                    setConfirmLoading(false);
                    setOpen(false)
                });
            }
        },
        locale:{ removeFile: TranslateStringFin("removefile") },
        multiple: true,
        fileList: uploadedFileList,
    };

    const closePopup = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        const deleteData = {
            loan_status_doc_status: 0
        }

        setConfirmLoading(true);
        SingleLoanServices
            .deleteAttachment(deleteData, deleteVal?.loan_status_id)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    message.success(response?.data?.msg);
                    getTenderRequestData(props?.tender_req_id, false)
                    setOpen(false)
                }
                if (response?.data?.code === 500) {
                    message.error(response?.data?.msg);
                    setOpen(false)
                }
                setConfirmLoading(false);
            })
            .catch((err: any) => {
                message.error("There was some error");
                console.log(err)
                setConfirmLoading(false);
                setOpen(false)
            });
    };


    const onSelectNoOffer = () => {
        Modal.confirm({
            title: TranslateStringFin('are_you_sure_you_want_to_leave_an_offer'),
            icon: <ExclamationCircleFilled />,
            okText: TranslateStringFin('yes'),
            okButtonProps: { className: "cu-btn-green rounded" },
            cancelText: TranslateStringFin('cancel'),
            cancelButtonProps: { className: "cu-border-green cu-text-green rounded" },
            
            onOk() {
                let phoneCode = contactPhoneCode ? contactPhoneCode.trim(): '';
                let phone = contactPhone ? contactPhone.trim(): '';
                let formDataLocal: any = {
                    tender_req_status: 2,
                    loan_data_name: tenderRequestData?.LOAN_DATA?.loan_data_name,
                    loan_tender_id: tenderRequestData?.loan_tender_id,
                    loan_data_customername:tenderRequestData?.LOAN_DATA?.loan_data_customername,
                    offer_contact_name: contactName,
                    offer_contact_email: contactEmail,
                    offer_contact_phone: phoneCode ? "+" + phoneCode?.trim() +" "+phone?.trim() : phone?.trim(),
                    offer_message: offerMessage,
                    loan_data_agreement: tenderRequestData?.LOAN_DATA?.loan_data_agreement,
                    time_remaining: tenderRequestData?.LOAN_DATA?.time_remaining,
                    update_by:props?.type === 'bank'?'bank':'moderator_offer',
                    offer_submit_at: new Date()
                }

                setLoading(true);
                SingleLoanServices
                    .updateLoanOffer(formDataLocal, tenderRequestData?.tender_req_id)
                    .then((response: any) => {
                        if (response?.data?.code === 200) {
                            message.success(TranslateStringFin("updated_successfully"));
                        } else if (response?.data?.code === 500) {
                            message.error(TranslateStringFin('tender_deadline_is_passed'));
                        }
                        setLoading(false);
                    })
                    .catch((err: any) => {
                        console.log(err)
                        setLoading(false);
                    });
            },
            onCancel() {
            },
        });
    };

    const handleReset = () => {
        getTenderRequestData(props?.tender_req_id, false, true)
    }

    return (
        <>
            <Spin spinning={loading}>
                <div className="ant-card ant-card-bordered cu-mb-10 cu-px-10 w-100 text-left">
                    {
                        props?.type === 'bank' ?
                            <h4 className="cu-m-0 cu-p-0">
                                <button className="ant-btn cu-border-0 cu-btn h4">{TranslateStringFin('bank')} : {tenderRequestData?.BANK_DATA?.bank_name}</button>
                            </h4> :
                            <Link to={`/single-loan/${tenderRequestData?.LOAN_DATA?.loan_data_customerid}/${tenderRequestData?.loan_tender_id}/2`}>
                                <h4 className="cu-m-0 cu-p-0">
                                    <button className="ant-btn cu-border-0 cu-btn"><FaArrowLeft style={{ fontWeight: 900, fontSize: '18px' }} /></button>
                                    &nbsp;
                                    <button className="ant-btn cu-border-0 cu-btn h4">{ TranslateStringFin('single_loan_view_moderator')}</button>
                                </h4>
                            </Link>
                    }

                </div>
                <Form
                    requiredMark={false}
                    form={form}
                    layout={`vertical`}
                    name="control-ref"
                    onFinish={onFormSubmit}
                    className="mb-5"
                >
                    
                    {
                        (() => {
                            if (props?.type === 'bank') {
                                return (
                                     (loanDataInfo !== "internal_new" && loanDataInfo !== "external_new") &&
                                        <table className="table table-bordered table-sm">
                                        <thead>
                                            <tr className="cu-bg-green">
                                                {/* <th rowSpan={2} style={{ width: "35%" }}>{props?.type === "bank" ? TranslateStringFin('bank') : TranslateStringFin('bank')}</th> */}
                                                <th className="text-right" style={{ width: "50%" }}>{TranslateStringFin('capital')}</th>
                                                <th className="text-right">{TranslateStringFin('loan_span')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {/* <td className="fs-4">{tenderRequestData?.BANK_DATA?.bank_name}</td> */}
                                                <td className="text-right fs-4">{tenderRequestData?.LOAN_DATA?.loan_data_agreement}</td>
                                                <td className="text-right fs-4">{tenderRequestData?.LOAN_DATA?.time_remaining}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                );
                            } else {
                                return (
                                    <table className="table table-bordered table-sm text-left">
                                        <thead>
                                            <tr className="cu-bg-green">
                                                <th>{TranslateStringFin('customer_name')}</th>
                                                <th style={{ width: "35%" }}>{ TranslateStringFin('bank')}</th>
                                                <th className="text-right" style={{ width: "10%" }}>{TranslateStringFin('current_capital')}</th>
                                                <th className="text-right" style={{ width: "15%" }}>{TranslateStringFin('loan_time_remaining')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th className="fs-4">{tenderRequestData?.LOAN_DATA?.loan_data_customername}</th>
                                                <td className="fs-4">{tenderRequestData?.BANK_DATA?.bank_name}</td>
                                                <td className="text-right fs-4 text-nowrap">{tenderRequestData?.LOAN_DATA?.loan_data_agreement}</td>
                                                <td className="text-right fs-4">{tenderRequestData?.LOAN_DATA?.time_remaining}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )
                            }
                        })()
                    }
                    <Card className="bg-light text-left">
                        <Card.Body>
                            <ARow>
                                <ACol span={props?.type === "bank" ? 3 : 2}>
                                    <Form.Item name="offer_margin" label={<><span>{TranslateStringFin('margin_percentage')}</span>
                                    <span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required:  true,
                                                message: TranslateStringFin('please_enter_number'),
                                                pattern: new RegExp(/^[\d,\s]+$/)
                                            },
                                        ]}>
                                        <Input />
                                    </Form.Item>
                                    
                                </ACol>
                                &emsp;
                                <ACol span={4}>
                                    <Form.Item
                                        name="offer_payment_method"
                                        label={<><span>{TranslateStringFin((loanDataInfo === "internal_new" || loanDataInfo === "external_new") ? 'payment_method' : 'payment_method')}</span><span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateStringFin('please_select_payment_method'),
                                            },
                                        ]}
                                    >
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '100%' }}
                                            placeholder={TranslateStringFin('select')}
                                            options={PaymentMethodOptions}
                                        />
                                    </Form.Item>
                                </ACol>
                                &emsp;
                                <ACol span={3}>
                                    <Form.Item
                                        name="offer_ref_rate_base"
                                        label={<><span>{ TranslateStringFin((loanDataInfo === "internal_new" || loanDataInfo === "external_new") ? 'reference_rate_base' : 'reference_rate_base')}</span><span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateStringFin('please_select_base_rate'),
                                            },
                                        ]}
                                    >
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '100%' }}
                                            placeholder={TranslateStringFin('select')}
                                            options={ReferenceRateBaseOptions}
                                        />
                                    </Form.Item>
                                </ACol>
                                &emsp;
                                <ACol span={props?.type === "bank" ? 3 : 4}>
                                    <Form.Item name="offer_interval" label={<><span>{ TranslateStringFin((loanDataInfo === "internal_new" || loanDataInfo === "external_new") ? 'payment_interval_months' :'payment_interval_months')}</span><span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateStringFin('please_enter_number_between_1_and_12'),
                                                pattern: new RegExp(/^([1-9]|1[012])$/)
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </ACol>
                                {props?.type === "bank" ? "" : <>&emsp;<ACol span={2}>
                                    <Form.Item name="offer_span_year" label={<><span>{TranslateStringFin('loan_span_years')}</span><span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                // message: TranslateStringFin('please_enter_number'),
                                                 message: TranslateStringFin('enter_numeric_digit_number_less_than_100'),
                                                // pattern: new RegExp(/^[-\d,\s]+$/)
                                                // pattern: new RegExp(/^(?=.*\d)[0-9,]{1,3}$/)
                                                // pattern: new RegExp(/^(?:\d{1,2}|\d,\d)$/)
                                                //  pattern: new RegExp(/^(?:0|[1-9]\d{0,2}|1000|[1-9]\d?,\d)$/),
                                                 pattern: new RegExp(/^(?:0|[1-9]\d?|[1-9]\d?,\d)$/),

                                            },
                                        ]}
                                    >
                                        <Input/>
                                    </Form.Item>
                                </ACol></>}
                                {props?.type === "bank" ? "" : <>&emsp;<ACol sm={3}>
                                    <Form.Item name="offer_span_year_modified" label={<><span className="text-nowrap">{ TranslateStringFin('loan_time_modified')}</span></>}
                                        rules={[
                                            {
                                                required: false,
                                                message: TranslateStringFin('enter_numeric_digit_number_less_than_100'),
                                                // pattern: new RegExp(/^[-\d,\s]+$/)
                                                // pattern: new RegExp(/^(?=.*\d)[0-9,]{1,3}$/)
                                                // pattern: new RegExp(/^(?:\d{1,2}|\d,\d)$/)
                                                //  pattern: new RegExp(/^(?:0|[1-9]\d{0,2}|1000|[1-9]\d?,\d)$/),
                                                 pattern: new RegExp(/^(?:0|[1-9]\d?|[1-9]\d?,\d)$/),

                                            },
                                        ]}
                                    >
                                        <Input/>
                                    </Form.Item>
                                </ACol></>}
                                &emsp;
                                { (loanDataInfo === 'internal_new' || loanDataInfo === "external_new") ?

                                <ACol span={props?.type === "bank" ? 5 : 4}>
                                    <Form.Item name="max_loan_time" label={<><span>{ TranslateStringFin('maximum_loan_time')}</span><span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateStringFin('enter_numeric_digit_number_less_than_100'),
                                                // pattern: new RegExp(/^[\d,\s]+$/)
                                                // pattern: new RegExp(/^(?=.*\d)[0-9,]{1,3}$/)
                                                // pattern: new RegExp(/^(?:\d{1,2}|\d,\d)$/)
                                                //  pattern: new RegExp(/^(?:0|[1-9]\d{0,2}|1000|[1-9]\d?,\d)$/),
                                                 pattern: new RegExp(/^(?:0|[1-9]\d?|[1-9]\d?,\d)$/),

                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </ACol>
                                :
                                <ACol span={props?.type === "bank" ? 6 : 5}>
                                    <Form.Item name="offer_sanction" label={<><span>{ TranslateStringFin('sanction_for_yearly_payment')}</span><span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateStringFin('please_enter_number'),
                                                pattern: new RegExp(/^[\d,\s]+$/)
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </ACol>
                                }
                                &emsp;
                                <ACol span={props?.type === "bank" ? 3 : 3}>
                                    <Form.Item name="offer_fee" label={<><span>{ TranslateStringFin('arrangement_fee')}</span>
                                    <span className="text-danger">*</span></>}
                                        rules={[
                                            {
                                                required: true,
                                                message: TranslateStringFin('please_enter_number'),
                                                pattern: new RegExp(/^[\d,]+$/)
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </ACol>
                                {
                                    (props?.type === 'bank') ?
                                        <>&emsp;<ACol span={5} className={(props?.type === 'bank') ? 'd-none' : ''}>
                                            <Form.Item name="offer_estimated_mortage_price" label={<><span>{ TranslateStringFin('estimated_price_of_mortgage_transfer')}</span><span className="text-danger">*</span></>}
                                                rules={[
                                                    {
                                                        message: TranslateStringFin('please_enter_number'),
                                                        pattern: new RegExp(/^[\d,]+$/)
                                                    },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </ACol></> :
                                        <>&emsp;<ACol span={5} >
                                            <Form.Item name="offer_estimated_mortage_price" label={<><span>{ TranslateStringFin('estimated_price_of_mortgage_transfer')}</span><span className="text-danger">*</span></>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: TranslateStringFin('please_enter_number'),
                                                        pattern: new RegExp(/^[\d,]+$/)
                                                    },
                                                ]}
                                            >
                                                <Input />
                                            </Form.Item>
                                        </ACol></>
                                }
                                &emsp;
                                <ACol span={5}>
                                    <Form.Item 
                                    name="offer_transfer_payment"
                                     label={ TranslateStringFin('transferring_payment_transaction_mandatory')}
                                     >
                                        <Radio.Group>
                                            <Radio value="1">{TranslateStringFin('yes')}</Radio>
                                            <Radio value="0">{TranslateStringFin('no')}</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </ACol>
                                &emsp;
                                <ACol span={5}>
                                        <ConfigProvider locale={localeFI}>
                                            <Form.Item
                                                name="offer_valid_date"
                                                label={<><span>{TranslateStringFin('valid_until')}</span> 
                                                <span className="text-danger">*</span></> }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: TranslateStringFin('please_select_valid_until_date'),
                                                    },
                                                ]}
                                            >
                                                    <DatePicker format={"DD.MM.YYYY"} className="w-100" placeholder={TranslateStringFin("select_date") } />
                                            </Form.Item>
                                        </ConfigProvider>
                                </ACol>
                            </ARow>
                            <Row>
                                <Col sm={5}>
                                    <Form.Item label={<><span>{ TranslateStringFin('attachment')}</span><span className="text-danger">*</span></>} className="w-100" >
                                        <Upload {...propsFile} className="text-dark">
                                            <Tooltip title={TranslateStringFin('upload')}>
                                                <AntdButton className="rounded" icon={<UploadOutlined />}>{TranslateStringFin('upload')}</AntdButton>
                                            </Tooltip>
                                        </Upload>
                                    </Form.Item>
                                </Col>
                                <Col sm={4}>
                                    <Form.Item label={ TranslateStringFin('contact_info')}>
                                        <div className="d-flex justify-content-between">
                                            {props?.type === "bank" ? <><div className="ant-form-item-label text-nowrap">{ TranslateStringFin('name')}</div>&emsp;&emsp;&emsp;&emsp;</> : <><div className="ant-form-item-label">{TranslateStringFin('name')}</div>&emsp;</>}
                                            <div style={{width:'65%'}}>
                                                <Form.Item name="offer_contact_name" >
                                                    <Input readOnly={(props?.type === 'bank') ? false : true}
                                                    onChange={e => setContactName(e.target.value)} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <div className="mr-1 ant-form-item-label  text-nowrap">{ TranslateStringFin('email')} { props?.type === "bank" && <span className="text-danger">*</span> } </div>&emsp;
                                            <div style={{width:'65%'}}>
                                                <Form.Item name="offer_contact_email"
                                                rules={[{ 
                                                    required: props?.type === "bank" ? true : false, 
                                                    message: TranslateStringFin('the_input_is_not_valid_email_bank'), 
                                                    type: "email" 
                                                    }]} >
                                                    <Input readOnly={(props?.type === 'bank') ? false : true} onChange={e => setContactEmail(e.target.value)} />
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            {props?.type === "bank" ? <><div className="ant-form-item-label text-nowrap">{ TranslateStringFin('phone')}</div>&emsp;&emsp;&emsp;</> : <><div className="ant-form-item-label">{TranslateStringFin('phone')}</div>&emsp;</>}
                                                <div style={{width:'65%'}} className="d-flex">
                                                    <div style={{width:'35%'}}>
                                                        <Form.Item
                                                            name="offer_contact_phone_code"
                                                            rules={[{ required: false, message: TranslateStringFin('please_enter_phone_number_between_8_to_12_digits'), 
                                                            pattern: new RegExp(/^(\d{2}|\d{3})$/)}]}
                                                        >
                                                        <Input
                                                            addonBefore={<AiOutlinePlus style={{fontSize: "13px"}} />}
                                                            readOnly={(props?.type === 'bank') ? false : true}
                                                            onChange={e => setContactPhoneCode(e.target.value)}
                                                        />
                                                    </Form.Item>
                                                    </div>
                                                    <div style={{width: '65%'}}>
                                                        <Form.Item name="offer_contact_phone"
                                                        rules={[{
                                                            validator(rule, value){
                                                                return new Promise((resolve, reject) => {
                                                                    let pattern= new RegExp(/^(\d{7}|\d{8}|\d{9}|\d{10}|\d{11}|\d{12}|\d{13})$/);
                                                                    let currentVal="";
                                                                    if(value && value.length > 0){
                                                                        currentVal = value.replace(/ +/g, "");
                                                                    }
                                                                    if(currentVal.match(pattern) && (currentVal.length > 6 && currentVal.length < 14 )){
                                                                        resolve(true);
                                                                    } else if (currentVal !== "") {
                                                                        reject(intl.formatMessage({ id: convertToObjectKeyString('please_enter_phone_number_between_8_to_12_digits') }))
                                                                    } else {
                                                                        resolve(true);
                                                                    }
                                                                })
                                                            }
                                                            }]}
                                                            >
                                                            <Input readOnly={(props?.type === 'bank') ? false : true} onChange={e => setContactPhone(e.target.value)} />
                                                        </Form.Item>
                                                    </div>
                                                </div>
                                        </div>
                                    </Form.Item>
                                </Col>
                                <Col sm={3}>
                                    <Form.Item name="offer_message" label={ TranslateStringFin('message')}>
                                        <Input.TextArea readOnly={(props?.type === 'bank') ? false : true} rows={4} onChange={e => setOfferMessage(e.target.value)} />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                    <Card className="bg-light text-left d-none">
                        <table className="table table-bordered table-sm table-striped">
                            <thead>
                                <tr className="cu-bg-green">
                                    <th>Valid until</th>
                                    <th>Margin</th>
                                    <th>Interest base</th>
                                    <th>Downpayment type</th>
                                    <th>Section</th>
                                    <th>Fee</th>
                                    <th>Document</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                </tr>
                                <tr>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </tbody>
                        </table>
                    </Card>
                    <div className="d-flex justify-content-end px-3 my-3">
                        <Button type="reset" className="btn btn-sm bg-secondary px-4 border-secondary" onClick={handleReset}>{TranslateStringFin('reset')}</Button>
                        &nbsp;
                        {props?.type === 'bank' && <Button onClick={() => { onSelectNoOffer() }} className="btn btn-sm cu-btn-green px-3">{TranslateStringFin('no_offer')}</Button>}
                        &nbsp;
                        <Button onClick={() => {
                            setOpen(true)
                            setState("submit")
                        }} className="btn btn-sm cu-btn-green px-3" disabled={loading ? true : false}>{!loading ? TranslateStringFin('Submit') : TranslateStringFin('Please wait')}</Button>
                    </div>
                </Form>
            </Spin>
            <Modal
                title=""
                open={open}
                onOk={() => {
                    if(state === "submit"){
                        form.submit();
                        setOpen(false);
                    }else{
                        handleDelete()
                    }
                }}
                okButtonProps={{ className: 'cu-bg-green' }}
                okText={TranslateStringFin('yes')}
                cancelButtonProps={{ className: 'cu-bg-green' }}
                cancelText= {TranslateStringFin('cancel')}
                confirmLoading={confirmLoading}
                onCancel={closePopup}
            >
                <p className='h5'>{state === "submit" ? TranslateStringFin('are_you_sure_you_want_to_submit') : TranslateStringFin('are_you_sure_you_want_to_delete_this_attachment')}</p>
            </Modal>
        </>
    );
};
export default SingleLoanViewModeratorForm;
